/* ============================================================
   KingSidorak Navigation — click-triggered dropdowns + search
   ============================================================ */
(function () {
  'use strict';

  var nav = document.getElementById('ks-nav');
  var overlay = document.getElementById('ks-overlay');
  if (!nav) return;

  var allBtns = Array.prototype.slice.call(nav.querySelectorAll('[data-ks-btn]'));

  /* Close every open panel */
  function closeAll() {
    allBtns.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (panel) panel.hidden = true;
    });
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('ks-nav-open');
  }

  /* Toggle a panel on button click */
  allBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAll();
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        var panelId = btn.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);
        if (panel) panel.hidden = false;
        if (overlay) overlay.hidden = false;
        document.body.classList.add('ks-nav-open');
      }
    });
  });

  /* Close buttons inside panels */
  var closeBtns = Array.prototype.slice.call(document.querySelectorAll('[data-ks-close]'));
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeAll);
  });

  /* Clicking the overlay closes everything */
  if (overlay) {
    overlay.addEventListener('click', closeAll);
  }

  /* Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* Click outside nav + panel closes dropdowns */
  document.addEventListener('click', function (e) {
    var collectionsPanel = document.getElementById('ks-collections-panel');
    var insideNav = nav && nav.contains(e.target);
    var insidePanel = collectionsPanel && collectionsPanel.contains(e.target);
    if (!insideNav && !insidePanel) closeAll();
  });

  /* ============================================================
     Amazon-style search — intercept submit to add tag filter
     ============================================================ */
  var searchForm = document.getElementById('ks-search-form');
  if (searchForm) {
    var searchInput = searchForm.querySelector('[data-ks-search-input]');
    var filterSelect = searchForm.querySelector('[data-ks-filter]');

    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = searchInput ? searchInput.value.trim() : '';
      var filter = filterSelect ? filterSelect.value.trim() : '';
      var query = q;
      if (filter) {
        query = q ? q + ' tag:' + filter : 'tag:' + filter;
      }
      if (!query) return;
      window.location.href = '/search?type=product&q=' + encodeURIComponent(query);
    });
  }

  /* ============================================================
     Mobile search bar toggle
     ============================================================ */
  var mobileSearchBtn = document.querySelector('.ks-mobile-search');
  var mobileSearchBar = document.getElementById('ks-mobile-search-bar');
  if (mobileSearchBtn && mobileSearchBar) {
    mobileSearchBtn.addEventListener('click', function () {
      var isOpen = mobileSearchBar.hidden === false;
      mobileSearchBar.hidden = isOpen;
      mobileSearchBtn.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        var input = mobileSearchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });

    /* Close on Escape */
    mobileSearchBar.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        mobileSearchBar.hidden = true;
        mobileSearchBtn.setAttribute('aria-expanded', 'false');
        mobileSearchBtn.focus();
      }
    });
  }
})();
